<template>
	<modal
		class="store-status-modal"
		size="medium"
		@close="close"
	>
		<template slot="header">
			<h3>Product Status</h3>
		</template>
		<template slot="body">
			<p class="text-center">
				Are you sure want to
				<span class="text-bold" :class="{
					'text-danger': productStatusState === 'suspend',
					'text-success': productStatusState === 'active',
				}">
					{{ productStatusState }}
				</span>
				<span class="text-bold">All Products</span> of
				<span class="text-bold">
					{{ isBulkUpdateProductStatus ? ` ${selectedItemsLength} ` : ` ${storeName} ` }}
				</span>
				Supplier<span v-if="isBulkUpdateProductStatus">s</span>?
			</p>
		</template>
		<template slot="footer">
			<!-- Close -->
			<button type="button" class="btn btn-light" @click="close">
				<span>{{ $t('Close') }}</span>
			</button>
			<!-- Update -->
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdatingProductStatus }"
				@click="update"
			>
				<span>{{ $t('Update') }}</span>
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalUpdateStoreStatus',
	components: {
		Modal,
	},
	props: {
		productStatusState: {
			type: String,
			default: 'active',
		},
		isBulkUpdateProductStatus: {
			type: Boolean,
			default: false,
		},
		isUpdatingProductStatus: {
			type: Boolean,
			default: false,
		},
		selectedItems: {
			default: () => [],
		},
		selectedItem: {
			default: null,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		update() {
			this.$emit('update');
		},
	},
	computed: {
		storeName() {
			return this.selectedItem?.store?.name ?? '';
		},
		selectedItemsLength() {
			return this.selectedItems?.length ?? 0;
		},
	},
};
</script>
